import Marquee from "react-fast-marquee";

const ITEMS = ["Chelmsford", "Essex", "In-Home", "Parks", "Workplace", "Garage Gym", "Garden"];

export const BrandMarquee = () => (
  <section className="py-8 md:py-12 border-y border-white/10 bg-[#020617]" data-testid="brand-marquee">
    <Marquee speed={45} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center">
          <span
            className={`font-display font-bold text-4xl md:text-6xl px-6 md:px-10 ${
              i % 2 === 0 ? "text-stroke-yellow" : "text-[#F8FAFC]"
            }`}
          >
            {t}
          </span>
          <span className="text-[#FACC15] text-3xl md:text-5xl">•</span>
        </div>
      ))}
    </Marquee>
  </section>
);
